import cls from "classnames";
import FieldWrapper from "./FieldWrapper";

export default function SocialLinkField({
  label,
  type,
  name,
  placeholder,
  onChange,
  disabled,
  formatValue,
  validator,
  required,
  hint,
  error,
  value,
  options,
  visible,
  className,
}) {
  function handleOnChange(e) {
    const protocolRegex = RegExp(/(^\w+:|^)\/\//);
    if (protocolRegex.test(e.target.value)) {
      e.target.value = e.target.value.replace(protocolRegex, "");
    }
    onChange(e, { formatValue, validator, required });
  }

  return (
    <FieldWrapper error={error} hint={hint} visible={visible}>
      {label && (
        <label htmlFor="input" className="font-semibold text-sm">
          {label}
        </label>
      )}

      <div className="flex flex-row items-center justify-start border-[1px] border-[#D5D8DC] outline-none w-full max-w-[420px] rounded-[4px] h-auto">
        <span className="p-2 bg-[#F7F7F8] border-r-[1px] border-[#D5D8DC] rounded-[4px] rounded-r-[0px]">
          https://
        </span>
        <input
          name={name}
          placeholder={placeholder}
          type={type}
          required={required}
          value={value}
          onChange={handleOnChange}
          disabled={disabled}
          className={cls(
            className
              ? className
              : "p-2 outline-none w-full max-w-[420px] rounded-r-[4px] h-auto",
            label ? "mt-0" : "-mt-3",
            disabled ? "cursor-not-allowed" : ""
          )}
        />
      </div>
    </FieldWrapper>
  );
}
